/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MonitEntityInsuranceResponse
 */
export interface MonitEntityInsuranceResponse {
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    policy_number?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    policy_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    broker_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    agency_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    agency_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    policyholder_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    policyholder_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    policyholder_phone?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    policyholder_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    account_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    industry_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    industry_gics?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    n_employees?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    pii_phi_count?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    company_revenue?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitEntityInsuranceResponse
     */
    aggregate_limit?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    quote_currency?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    country?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    retail_broker_name?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    retail_broker_email?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    effective_date?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    end_date?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    account_line_uuid?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitEntityInsuranceResponse
     */
    org_uuid?: string;
}

/**
 * Check if a given object implements the MonitEntityInsuranceResponse interface.
 */
export function instanceOfMonitEntityInsuranceResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MonitEntityInsuranceResponseFromJSON(json: any): MonitEntityInsuranceResponse {
    return MonitEntityInsuranceResponseFromJSONTyped(json, false);
}

export function MonitEntityInsuranceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitEntityInsuranceResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'policy_number': !exists(json, 'policy_number') ? undefined : json['policy_number'],
        'policy_uuid': !exists(json, 'policy_uuid') ? undefined : json['policy_uuid'],
        'broker_name': !exists(json, 'broker_name') ? undefined : json['broker_name'],
        'broker_email': !exists(json, 'broker_email') ? undefined : json['broker_email'],
        'broker_uuid': !exists(json, 'broker_uuid') ? undefined : json['broker_uuid'],
        'agency_name': !exists(json, 'agency_name') ? undefined : json['agency_name'],
        'agency_uuid': !exists(json, 'agency_uuid') ? undefined : json['agency_uuid'],
        'policyholder_name': !exists(json, 'policyholder_name') ? undefined : json['policyholder_name'],
        'policyholder_email': !exists(json, 'policyholder_email') ? undefined : json['policyholder_email'],
        'policyholder_phone': !exists(json, 'policyholder_phone') ? undefined : json['policyholder_phone'],
        'policyholder_uuid': !exists(json, 'policyholder_uuid') ? undefined : json['policyholder_uuid'],
        'account_uuid': !exists(json, 'account_uuid') ? undefined : json['account_uuid'],
        'industry_name': !exists(json, 'industry_name') ? undefined : json['industry_name'],
        'industry_gics': !exists(json, 'industry_gics') ? undefined : json['industry_gics'],
        'n_employees': !exists(json, 'n_employees') ? undefined : json['n_employees'],
        'pii_phi_count': !exists(json, 'pii_phi_count') ? undefined : json['pii_phi_count'],
        'company_revenue': !exists(json, 'company_revenue') ? undefined : json['company_revenue'],
        'aggregate_limit': !exists(json, 'aggregate_limit') ? undefined : json['aggregate_limit'],
        'quote_currency': !exists(json, 'quote_currency') ? undefined : json['quote_currency'],
        'country': !exists(json, 'country') ? undefined : json['country'],
        'retail_broker_name': !exists(json, 'retail_broker_name') ? undefined : json['retail_broker_name'],
        'retail_broker_email': !exists(json, 'retail_broker_email') ? undefined : json['retail_broker_email'],
        'effective_date': !exists(json, 'effective_date') ? undefined : json['effective_date'],
        'end_date': !exists(json, 'end_date') ? undefined : json['end_date'],
        'account_line_uuid': !exists(json, 'account_line_uuid') ? undefined : json['account_line_uuid'],
        'org_uuid': !exists(json, 'org_uuid') ? undefined : json['org_uuid'],
    };
}

export function MonitEntityInsuranceResponseToJSON(value?: MonitEntityInsuranceResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'policy_number': value.policy_number,
        'policy_uuid': value.policy_uuid,
        'broker_name': value.broker_name,
        'broker_email': value.broker_email,
        'broker_uuid': value.broker_uuid,
        'agency_name': value.agency_name,
        'agency_uuid': value.agency_uuid,
        'policyholder_name': value.policyholder_name,
        'policyholder_email': value.policyholder_email,
        'policyholder_phone': value.policyholder_phone,
        'policyholder_uuid': value.policyholder_uuid,
        'account_uuid': value.account_uuid,
        'industry_name': value.industry_name,
        'industry_gics': value.industry_gics,
        'n_employees': value.n_employees,
        'pii_phi_count': value.pii_phi_count,
        'company_revenue': value.company_revenue,
        'aggregate_limit': value.aggregate_limit,
        'quote_currency': value.quote_currency,
        'country': value.country,
        'retail_broker_name': value.retail_broker_name,
        'retail_broker_email': value.retail_broker_email,
        'effective_date': value.effective_date,
        'end_date': value.end_date,
        'account_line_uuid': value.account_line_uuid,
        'org_uuid': value.org_uuid,
    };
}

